// Local (per-browser) demo stays for showcasing the split-map with many pins.
// These live ONLY in localStorage — they never touch the upstream marketplace
// and are fully deletable (one-by-one or clear-all). Not visible to other users.

const KEY = "sf_demo_stays";

const IMAGES = [
  "https://images.unsplash.com/photo-1645596032371-a7ac0892ca3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1759738103476-9abb3b59458e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1696482280456-00654f9bc25a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1640404967780-5963a0ffbe57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

const CITIES = [
  { city: "Guwahati", state: "Assam", lat: 26.1445, lng: 91.7362 },
  { city: "Jorhat", state: "Assam", lat: 26.7509, lng: 94.2037 },
  { city: "Golaghat", state: "Assam", lat: 26.5106, lng: 93.96 },
  { city: "Kaziranga", state: "Assam", lat: 26.5775, lng: 93.1711 },
  { city: "Tezpur", state: "Assam", lat: 26.6338, lng: 92.7926 },
  { city: "Dibrugarh", state: "Assam", lat: 27.4728, lng: 94.912 },
  { city: "Sivasagar", state: "Assam", lat: 26.9826, lng: 94.6425 },
  { city: "Nagaon", state: "Assam", lat: 26.3484, lng: 92.684 },
];

// noun carries a keyword so the category chips (homestay/tea/river/eco/hotel/resort) filter demos.
const TYPES = [
  { type: "Homestay", noun: "Family Homestay" },
  { type: "Tea Estate", noun: "Tea Estate Bungalow" },
  { type: "Riverfront", noun: "Riverfront Villa" },
  { type: "Eco Cottage", noun: "Eco Cottage" },
  { type: "Hotel", noun: "Boutique Hotel" },
  { type: "Resort", noun: "Jungle Resort" },
];

const ADJ = [
  "Brahmaputra", "Emerald", "Sunrise", "Misty Hills", "Bamboo Grove", "Golden Paddy",
  "Cinnamon", "Riverbend", "Teak House", "Orchid", "Hornbill", "Silk Route",
  "Cloud Valley", "Kaziranga", "Green Leaf", "Blue Lotus",
];

const rand = (a, b) => a + Math.random() * (b - a);

export const buildDemoStays = (count = 30) => {
  const out = [];
  for (let i = 0; i < count; i++) {
    const c = CITIES[i % CITIES.length];
    const t = TYPES[i % TYPES.length];
    const img0 = IMAGES[i % IMAGES.length];
    const photos = [img0, IMAGES[(i + 1) % IMAGES.length], IMAGES[(i + 2) % IMAGES.length]].map((url) => ({ url }));
    out.push({
      id: `demo-${i + 1}-${Math.random().toString(36).slice(2, 7)}`,
      __demo: true,
      name: `${ADJ[i % ADJ.length]} ${t.noun}`,
      type: t.type,
      property_type: t.type,
      city: c.city,
      state: c.state,
      country: "India",
      min_price_per_night: Math.round(rand(1200, 6000) / 100) * 100,
      rating: Math.round(rand(4.2, 5.0) * 100) / 100,
      reviews_count: Math.round(rand(6, 120)),
      beds: 1 + (i % 4),
      cover_image: img0,
      photos,
      lat: +(c.lat + rand(-0.08, 0.08)).toFixed(5),
      lng: +(c.lng + rand(-0.1, 0.1)).toFixed(5),
    });
  }
  return out;
};

const emit = () => window.dispatchEvent(new Event("sf-demo"));

export const getDemoStays = () => {
  try { const v = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(v) ? v : []; }
  catch { return []; }
};

export const seedDemoStays = (count = 30) => {
  const list = buildDemoStays(count);
  localStorage.setItem(KEY, JSON.stringify(list));
  emit();
  return list;
};

export const deleteDemoStay = (id) => {
  const next = getDemoStays().filter((d) => d.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  emit();
  return next;
};

export const clearDemoStays = () => {
  localStorage.removeItem(KEY);
  emit();
};
